import { BacteriaAttention } from '@snapi/types';
import { Percentage, Subtitle, Description } from '@snapi/luxury';
import { bacteriaName } from '@snapi/ui-utils';
import clsx from 'clsx';

export const ReportRelatedCardPdf: React.FC<BacteriaAttention> = ({
  name,
  taxonomy,
  percentage,
  threshold,
  comparator,
  category,
  categoryType,
  description,
}) => {
  return (
    <div className="flex flex-col bg-white rounded-[10px] pb-4 min-w-[670px]">
      <div className="relative flex flex-1 flex-col flex-shrink-0 bg-blue-light rounded-t-[10px] h-[230px] px-3 py-4">
        <div className="flex flex-col gap-2">
          {category === 'disruptive' || categoryType === 'disruptive' ? (
            <small className="flex flex-shrink-0 self-start px-4 pb-4 rounded-full bg-red text-white uppercase">
              Disruptive
            </small>
          ) : (
            <small className="flex flex-shrink-0 self-start px-4 pb-4 rounded-full bg-green text-body uppercase">
              Protective
            </small>
          )}
          <h4 className="flex flex-1">{bacteriaName(name, taxonomy)}</h4>
        </div>
        <div className="my-3 relative mb-4">
          <div className="absolute border-b border-body pb-1 opacity-30 top-0 bottom-0 -left-3 -right-3"></div>
        </div>
        <div className="flex gap-2">
          <div
            className={clsx(
              'flex flex-col basis-1/2 p-3  rounded-[10px] h-[80px] justify-between ',
              category === 'key' && Math.round(percentage * 10)/10 < threshold * 0.75
                ? 'bg-pink-light border-[1px] border-red'
                : 'bg-white',
              category === 'disruptive' ||
                (categoryType === 'disruptive' && Math.round(percentage * 10)/10 > threshold * 0.75)
                ? 'bg-pink-light border-[1px] border-red'
                : 'bg-white',
              category === 'condition' &&
                categoryType === 'ptotective' &&
                Math.round(percentage * 10)/10 < threshold * 0.75
                ? 'bg-pink-light border-[1px] border-red'
                : 'bg-white'
            )}
          >
            <div className="border-b-[0.5px] border-body pb-2 text-[12px] leading-[17px]">
              <Subtitle>Your result now</Subtitle>
            </div>

            <Percentage
              className="text-[26px] font-semibold mt-2"
              percentage={percentage}
            />
          </div>
          <div className="flex flex-col basis-1/2 p-3 bg-white rounded-[10px] h-[80px] justify-between">
            <div className="border-b-[0.5px] border-body pb-2 text-[12px] leading-[17px] ">
              <Subtitle>Your goal</Subtitle>
            </div>

            <h5 className="mt-2 flex flex-row items-center justify-start">
              {category === 'disruptive' || categoryType === 'disruptive'
                ? 'under'
                : 'over'}
              <Percentage
                className="text-[26px] font-semibold ml-2"
                percentage={threshold * 0.75}
              />
            </h5>
          </div>
        </div>
      </div>
      <div>
        <span className="flex relative my-2 pl-3">
          {category === 'disruptive' || categoryType === 'disruptive' ? (
            <small className="mt-1 flex flex-shrink-0 self-start px-4 pb-4 rounded-full bg-red text-white uppercase">
              Disruptive
            </small>
          ) : (
            <small className="mt-1 flex flex-shrink-0 self-start px-4 pb-4 rounded-full bg-green text-body uppercase">
              Protective
            </small>
          )}
          <h6 className="ml-4 uppercase">What to know</h6>
        </span>
        <div className="flex flex-1 flex-col gap-3 px-3">
          {description?.map((description, i) => (
            <div className="flex relative" key={i}>
              <div className="absolute text-xl font-black top-[-6px]">.</div>
              <div className="ml-3">
                {' '}
                <Description>{description}</Description>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
